import axios from "../axios";
import h from "../helpers";

const warehouseTransfer = {
  index: async (params) => {
    const { data } = await axios.get(h.baseUrl("warehouse-transfer"), { params: { ...params } });
    return data;
  },
  show: async (id) => {
    const { data } = await axios.get(h.baseUrl("warehouse-transfer/" + id));
    return data;
  },
  create: async (body) => {
    const { data } = await axios.post(h.baseUrl("warehouse-transfer"), body);
    return data;
  },
  update: async (id, body) => {
    const { data } = await axios.put(h.baseUrl("warehouse-transfer/" + id), body);
    return data;
  },
  delete: async (id) => {
    const { data } = await axios.delete(h.baseUrl("warehouse-transfer/" + id));
    return data;
  },
  addDetail: async (id, body) => {
    const { data } = await axios.post(h.baseUrl("warehouse-transfer/" + id + "/detail"), body);
    return data;
  },
  updateDetail: async (id, detailId, body) => {
    const { data } = await axios.put(h.baseUrl("warehouse-transfer/" + id + "/detail/" + detailId), body);
    return data;
  },
  deleteDetail: async (id, detailId) => {
    const { data } = await axios.delete(h.baseUrl("warehouse-transfer/" + id + "/detail/" + detailId));
    return data;
  },
  ship: async (id) => {
    const { data } = await axios.post(h.baseUrl("warehouse-transfer/" + id + "/ship"));
    return data;
  },
  cancel: async (id) => {
    const { data } = await axios.post(h.baseUrl("warehouse-transfer/" + id + "/cancel"));
    return data;
  },
};

export default warehouseTransfer;
